var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientsLoaded && _vm.usersLoaded)?_c('div',{staticClass:"bbp-request-form"},[_c('BBPForm',{attrs:{"btnTextRight":_vm.request.id ? 'SAVE' : 'ADD',"defaultModel":_vm.updateBody,"title":_vm.titleForm,"inputs":_vm.inputs,"project":_vm.request},on:{"close":_vm.closeForm,"save":_vm.saveForm}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6338ba65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Requests/RequestForm/RequestForm.vue
// module id = null
// module chunks = 